import { useEffect, useState } from "react";
import { getFbFormsApi, updateFbFormStatusApi } from "../apiServices/fbFormServices";

const useFbForms = (params = {}) => {

  const [forms, setForms] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchForms = async () => {
    try {

      setLoading(true);

      const res = await getFbFormsApi(params);

      setForms(res?.data?.forms || []);

      setPagination({
        page: res?.data?.page || 1,
        totalPages: res?.data?.totalPages || 1,
        total: res?.data?.total || 0,
      });

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);
    }
  };

  const updateStatus = async (id, leadSyncStatus) => {
    await updateFbFormStatusApi(id, { leadSyncStatus });
    fetchForms();
  };

  useEffect(() => {

    const delay = setTimeout(() => {
      fetchForms();
    }, 400);

    return () => clearTimeout(delay);

  }, [JSON.stringify(params)]);

  return {
    forms,
    loading,
    pagination,
    fetchForms,
    updateStatus,
  };
};

export default useFbForms;